export default __webpack_public_path__ + "static/media/add.01a9f535.svg";